import { Component } from '@angular/core';
import { assets } from '../../../../core/constants/assets.const';

@Component({
  selector: 'logibids-post-enq-infographics',
  imports: [],
  templateUrl: './post-enq-infographics.component.html',
  styleUrl: './post-enq-infographics.component.scss',
})
export class PostEnqInfographicsComponent {
  assets = assets;
}
